import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query GetMultiPromptRunnerStatus($projectId: ID!, $chainId: ID, $csvChainId: ID) {
    getMultiPromptRunnerStatus(projectId: $projectId, chainId: $chainId, csvChainId: $csvChainId) {
      chainId
      csvChainId
      status
    }
  }
`;

export const getMultiPromptRunnerStatus = async ({ projectId, chainId, csvChainId }) => {
  const variables = {
    projectId,
    chainId,
    csvChainId,
  };

  const response = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  return getSingleProp(response.data);
};
